// @ts-strict-ignore
import type { MultiSelectProps } from '@usealloy/component-library';
import { IconName } from '@usealloy/component-library';

export const MULTISELECT_PROPS: {
  customStyleFunctions: MultiSelectProps['customStyleFunctions'];
  isMulti: boolean;
  isNaked: boolean;
  isSearchable: boolean;
  showCheckmark: boolean;
  visibleSelectedOptions: boolean;
  dynamicMenuHeight: boolean;
  useFixedMenuPosition: boolean;
} = {
  customStyleFunctions: {
    container: () => ({
      margin: '0',
    }),
    singleValue: () => ({
      borderTop: '3px solid transparent',
      borderBottom: '3px solid transparent',
      fontFamily: 'var(--cl-font-family-mono)',
      fontSize: 'var(--cl-font-size-2)',
      fontWeight: 'bold',
    }),
    placeholder: () => ({
      fontFamily: 'var(--cl-font-family-mono)',
    }),
    option: (_styles, { isFocused }) => ({
      backgroundColor: isFocused ? 'var(--cl-gray-200)' : undefined,
      width: 'auto',
      padding: 'var(--cl-space-3)',
      fontFamily: 'var(--cl-font-family-mono)',
      fontSize: 'var(--cl-font-size-2)',
    }),
  },
  isMulti: false,
  showCheckmark: false,
  isNaked: true,
  isSearchable: true,
  visibleSelectedOptions: true,
  dynamicMenuHeight: true,
  // Prevent react-select's autoUpdate from causing infinite loops when used with ResizeObserver (BUILD-3903)
  useFixedMenuPosition: true,
};


export const MULTISELECT_HOVER_SEMITRANSLUCENT_PROPS: {
  customStyleFunctions: MultiSelectProps['customStyleFunctions'];
  isMulti: boolean;
  isNaked: boolean;
  isSearchable: boolean;
  visibleSelectedOptions: boolean;
} = {
  ...MULTISELECT_PROPS,
  customStyleFunctions: {
    container: () => ({
      margin: '0',
    }),
    singleValue: MULTISELECT_PROPS.customStyleFunctions.singleValue,
    valueContainer: () => ({
      padding: '0 2px',
    }),
  },
};

export const DEFAULT_TAG_COLOR = 'var(--cl-gray-700)';
// todo - add a helper that converts css vars to hex colors
// this is equivalent to var(--cl-gray-700)
export const DEFAULT_TAG_COLOR_IN_HEX_FORMAT = '7A7972';
export const DEFAULT_OUTCOME_COLOR_IN_HEX_FORMAT = '646461';
export const DEFAULT_OUTCOME_ICON_NAME = IconName.CustomOutcome;
